/**
 * Animate an element closed by transitioning its height to zero.
 *
 * @param {HTMLElement} element - The element to slide up.
 * @param {number} [duration=300] - Animation duration in milliseconds.
 * @returns {void}
 */
export function slideUp(element, duration = 300) {
    element.style.transition = `height ${duration}ms ease-out, padding ${duration}ms ease-out, margin ${duration}ms ease-out`;
    element.style.height = element.offsetHeight + "px";
    element.offsetHeight;
    element.style.overflow = "hidden";
    element.style.height = "0";
    element.style.paddingTop = "0";
    element.style.paddingBottom = "0";
    element.style.marginTop = "0";
    element.style.marginBottom = "0";

    setTimeout(() => {
        element.style.display = "none";
        element.style.removeProperty("height");
        element.style.removeProperty("padding-top");
        element.style.removeProperty("padding-bottom");
        element.style.removeProperty("margin-top");
        element.style.removeProperty("margin-bottom");
        element.style.overflow = "initial";
        element.style.removeProperty("transition");
        element.classList.remove("expanded");
    }, duration);
}

/**
 * Animate an element open by transitioning its height from zero to its natural height.
 *
 * @param {HTMLElement} element - The element to slide down.
 * @param {number} [duration=300] - Animation duration in milliseconds.
 * @param {string} [displayType] - Force this display value instead of the auto-detected one (e.g. "grid" for grid layouts).
 * @returns {void}
 */
export function slideDown(element, duration = 300, displayType) {
    element.style.removeProperty("display");
    let display = displayType ?? window.getComputedStyle(element).display;
    if (display === "none") display = "block";
    element.style.display = display;

    let height = element.offsetHeight;
    element.style.overflow = "hidden";
    element.style.height = "0";
    element.style.paddingTop = "0";
    element.style.paddingBottom = "0";
    element.style.marginTop = "0";
    element.style.marginBottom = "0";
    element.offsetHeight;
    element.style.transition = `height ${duration}ms ease-out, padding ${duration}ms ease-out, margin ${duration}ms ease-out`;
    element.style.height = height + "px";
    element.style.paddingTop = "";
    element.style.paddingBottom = "";
    element.style.marginTop = "";
    element.style.marginBottom = "";

    setTimeout(() => {
        element.style.height = "auto";
        element.style.overflow = "initial";
        element.style.removeProperty("transition");
        element.classList.add("expanded");
    }, duration);
}

/**
 * Toggle between slideUp and slideDown based on the element's current display state.
 *
 * @param {HTMLElement} element - The element to toggle.
 * @param {number} [duration=300] - Animation duration in milliseconds.
 * @returns {void}
 */
export function slideToggle(element, duration = 300) {
    if (window.getComputedStyle(element).display === "none") {
        slideDown(element, duration);
    } else {
        slideUp(element, duration);
    }
}
